import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { MuiThemeProvider } from '@material-ui/core/styles';
export const ThemeProvider = (props) => {
    const { theme } = props, rest = __rest(props, ["theme"]);
    return (_jsx(MuiThemeProvider, Object.assign({ theme: theme }, rest, { children: props.children }), void 0));
};
//# sourceMappingURL=ThemeProvider.js.map